import React, { useState } from "react";
import Notifications from "./notification";
import { useQuery } from "@apollo/react-hooks";
import { GET_NOTIFICATIONS } from "../../graphql/queries";

const NotificationsQueries = () => {
  const [pageNumberState, setPageNumberState] = useState(1);
  const [filterDataState, setFilterDataState] = useState("");
  const [channelState, setChannelState] = useState("");
  const [typeState, setTypeState] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [orderByASC, setOrderByASC] = useState(false);

  const { data, loading, refetch } = useQuery(GET_NOTIFICATIONS, {
    variables: {
      input: {
        regFrom: fromDate,
        regTo: toDate,
        pageNumber: pageNumberState,
        searchQuery: filterDataState,
      },
      channel: channelState,
      type: typeState,
      orderBy,
      orderByASC,
      csvDownload: false,
      driveUpload: false,
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  const handlePageNumberChange = (pageNumber: number) =>
    setPageNumberState(pageNumber);
  const handleFilterDataChange = (filterData: string) =>
    setFilterDataState(filterData);
  const handleChannelChange = (chnl: string) => setChannelState(chnl);
  const handleTypeChange = (tp: string) => setTypeState(tp);
  const handleFromDate = (date: string) => setFromDate(date);
  const handleToDate = (date: string) => setToDate(date);

  return (
    <Notifications
      data={data}
      loading={loading}
      onPageNumberChange={handlePageNumberChange}
      refetchData={refetch}
      onFilterDataChange={handleFilterDataChange}
      onSelectChannel={handleChannelChange}
      onSelectType={handleTypeChange}
      onFromDate={handleFromDate}
      onToDate={handleToDate}
      setOrderByASC={setOrderByASC}
      orderByASC={orderByASC}
      setOrderBy={setOrderBy}
      variables={{
        input: {
          regFrom: fromDate,
          regTo: toDate,
          pageNumber: pageNumberState,
          searchQuery: filterDataState,
        },
        channel: channelState,
        type: typeState,
      }}
    />
  );
};

export default NotificationsQueries;
